import { Component, OnInit, Input, SimpleChange } from '@angular/core';
import { ExamTest } from '../models/exam-test';

@Component({
  selector: 'app-exam-published-tests',
  templateUrl: './exam-published-tests.component.html',
  styleUrls: ['./exam-published-tests.component.scss']
})
export class ExamPublishedTestsComponent implements OnInit {

  constructor() { }

  @Input() tests: ExamTest[]
  @Input() selectedStudentName: string;
  @Input() title: string;
  @Input() totalExams: string;

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChange) {
    let testsVal = changes['tests'].currentValue;
    if (testsVal) {
      this.tests = testsVal.filter((obj, pos, arr) => {
        if(obj.examination_test_result_mode == 2 && (obj.examination_subject_result_mode == 1 || obj.examination_subject_result_mode == 2)){
          return arr.map(mapObj => mapObj.examination_subject_id).indexOf(obj.examination_subject_id) === pos;
        }
        else{
          return true;
        }
      });
    }
  }
}
